import { useState } from 'react'
import { useConversationApprovalPermission } from './useConversationApprovalPermission'
import { shouldClearSelectedTemplate } from '@app/common/utils/helpers'

/**
 * Hook to manage template text insertion and selected template state
 * Handles clearing selected template when user manually edits text
 *
 * @returns {Object} Object containing:
 *   - textToInsert: Current text value
 *   - selectedTemplate: Currently selected template
 *   - setTextToInsert: Function to set text (takes text and type: 'manual' | 'template')
 *   - setSelectedTemplate: Function to set selected template
 *   - handleTextToInsert: Handler function that manages both text and template clearing logic
 */
export const useTemplateTextHandler = () => {
  const [textToInsert, setTextToInsertState] = useState('')
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const userCanApproveMessage = useConversationApprovalPermission()

  const handleTextToInsert = (text, type) => {
    setTextToInsertState(text)

    // Only clear selectedTemplate if user is typing manually
    if (type === 'manual') {
      if (shouldClearSelectedTemplate({ selectedTemplate, userCanApproveMessage, textToInsert: text })) {
        setSelectedTemplate(null)
      }
      // Otherwise, keep selectedTemplate for non-pre-approved templates or pre-approved templates (if user can approve) so user can edit
    }
  }

  return {
    textToInsert,
    selectedTemplate,
    setTextToInsert: handleTextToInsert,
    setSelectedTemplate,
    handleTextToInsert,
  }
}
